var map = {
	"./atualidades-e-negocios/1.jpg": [
		138,
		0
	],
	"./celebridades-e-tv/1.jpg": [
		139,
		3
	],
	"./criancas-e-quadrinhos/1.jpg": [
		140,
		6
	],
	"./decoracao-e-jardinagem/1.jpg": [
		141,
		9
	],
	"./especializadas/1.jpg": [
		142,
		12
	],
	"./esportes/1.jpg": [
		143,
		15
	],
	"./estilo-de-vida-e-moda/1.jpg": [
		144,
		18
	],
	"./games-e-tecnologia/1.jpg": [
		145,
		21
	],
	"./gastronomia-e-receitas/1.jpg": [
		146,
		24
	],
	"./historia-e-educacao/1.jpg": [
		147,
		27
	],
	"./saude-e-bem-estar/1.jpg": [
		148,
		30
	],
	"./viagens-e-lazer/1.jpg": [
		149,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 94;
module.exports = webpackAsyncContext;